// Lightweight analytics shim. Forwards to window.dataLayer (GTM) if available,
// otherwise logs to console in dev. Safe to call on SSR.
export function trackEnquiryEvent(event, payload = {}) {
    if (typeof window === 'undefined') return;
    const data = { event, ...payload, ts: Date.now() };
    try {
        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push(data);
        }
        if (typeof window.gtag === 'function') {
            window.gtag('event', event, payload);
        }
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.debug('[enquiry]', event, payload);
        }
    } catch (_e) { /* ignore */ }
}
